<dashboard-dialog-frame [header]="'Edit chart'" [dialogRef]='dialogRef' [actions]="actions">

	<kendo-splitter>
		<kendo-splitter-pane size="50%">
			<div class="editor-pane">
				<kendo-tabstrip id="engagementViewerTabStrip">

					<kendo-tabstrip-tab title="Chat with AI" [selected]="true">
						<ng-template kendoTabContent>
							AI Chat goes here
						</ng-template>
					</kendo-tabstrip-tab>

					<kendo-tabstrip-tab title="Vega Code">
						<ng-template kendoTabContent>
							<ngx-monaco-editor [options]="editorOptions" [(ngModel)]="specString"
								(ngModelChange)="onSpecChange($event)">
							</ngx-monaco-editor>
						</ng-template>
					</kendo-tabstrip-tab>

				</kendo-tabstrip>
			</div>
		</kendo-splitter-pane>

		<kendo-splitter-pane>
			<div class="preview-pane">
				<div class="preview-toolbar">
					droplist here
				</div>
				<div class="preview-container">
					<div class="vega-grid">
						<div #chartContainer class="vega-container square"></div>
					</div>
				</div>
			</div>
		</kendo-splitter-pane>
	</kendo-splitter>

</dashboard-dialog-frame>